var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DeleteIcon } from '../Icons';
import React, { Suspense } from 'react';
import { FilePreviewWrapper } from '../StyledKYCComponents';
var FilePreviewPdf = React.lazy(function () { return import('./FilePreviewPdf'); });
export var FilePreview = function (_a) {
    var image = _a.image, isPdf = _a.isPdf, onDelete = _a.onDelete;
    return (_jsxs(FilePreviewWrapper, __assign({ image: isPdf ? undefined : image }, { children: [isPdf && image ? (_jsx(Suspense, { children: _jsx(FilePreviewPdf, { image: image }) })) : null, _jsx(DeleteIcon, { onClick: onDelete })] })));
};
